import { useEffect, useState } from "react";

import { getMonday } from "generated/api/monday";
import { getDictionary } from "generated/api/dictionary";

import { MondayGroupDTO, DictionaryDTO } from "generated/schemas";

export const useInitialData = (isOpen: boolean) => {
  const [strategies, setStrategies] = useState<MondayGroupDTO[]>([]);
  const [isLoadingStrategies, setIsLoadingStrategies] = useState(false);
  const [audienceTypes, setAudienceTypes] = useState<DictionaryDTO[]>([]);
  const [isLoadingAudiences, setIsLoadingAudiences] = useState(false);
  const [programTypes, setProgramTypes] = useState<DictionaryDTO[]>([]);
  const [isLoadingProgramTypes, setIsLoadingProgramTypes] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const fetchStrategies = async () => {
      setIsLoadingStrategies(true);

      try {
        const monday = getMonday();
        const results = await monday.getBoardGroups();
        setStrategies(results || []);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoadingStrategies(false);
      }
    };

    const fetchAudiences = async (dictionary: ReturnType<typeof getDictionary>) => {
      setIsLoadingAudiences(true);
      try {
        const results = await dictionary.getAudienceTypes();
        setAudienceTypes(results || []);
      } catch (error) {
        console.error("Failed to fetch audience types", error);
        setAudienceTypes([]);
      } finally {
        setIsLoadingAudiences(false);
      }
    };

    const fetchProgramTypes = async (dictionary: ReturnType<typeof getDictionary>) => {
      setIsLoadingProgramTypes(true);
      try {
        const results = await dictionary.getProgramTypes();
        setProgramTypes(results || []);
      } catch (error) {
        console.error("Failed to fetch program types", error);
        setProgramTypes([]);
      } finally {
        setIsLoadingProgramTypes(false);
      }
    };

    const dictionary = getDictionary();
    fetchStrategies();
    fetchAudiences(dictionary);
    fetchProgramTypes(dictionary);
  }, [isOpen]);

  return {
    strategies,
    isLoadingStrategies,
    audienceTypes,
    isLoadingAudiences,
    programTypes,
    isLoadingProgramTypes,
  };
};
